var viewSwitcher = class extends HTMLElement {
    button = this.querySelector(".view-switcher__toggle");

    connectedCallback() {
        let views = this.querySelectorAll(".view-switcher__view");
        let viewsContainer = this.querySelectorAll(".view-switcher__views-container");
        this.prepareViewSwitcher(views, viewsContainer);
        this.button.addEventListener("click", e => this.toggleView(e, views, viewsContainer));

    }

    prepareViewSwitcher(views, viewsContainer) {
        setTimeout(function () {
            var viewsArray = Array.from(views);
            var outerHeights = viewsArray.map(function (view) {
                return $(view).outerHeight();
            });

            Array.from(views).forEach(function (view) {
                const outerHeight = view.offsetHeight;
                view.setAttribute('data-height', outerHeight);
            });

            // in case of various views, one can be greater than the other and we will need to extract the greatest value
            var greatestValue = Math.max(...outerHeights);
            $(viewsContainer).css('height', outerHeights[0] + 'px');
        }, 1000);
    }

    toggleView(e, views, viewsContainer) {
        const button = $(e.currentTarget);
        console.log('test toggler')
        $(views).toggleClass("visible");
        const visibleView = this.querySelector(".view-switcher__view.visible");
        $(viewsContainer).css('height', visibleView.getAttribute(['data-height']) + 'px');
        if (button.hasClass('btn')) {
            button.removeClass('btn');
            button.addClass('link');
        } else {
            button.removeClass('link');
            button.addClass('btn');
        }
        this.button.querySelectorAll("span").forEach(function (span) {
            span.classList.toggle("visible");
        });
    }
};

window.customElements.define("view-switcher", viewSwitcher);
